exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg-admire[data-v-66dc36ed]{text-align:center}.msg-admire .bg-wrap[data-v-66dc36ed]{background:#ccc;color:#fff;display:inline-block;line-height:24px;font-size:12px;padding:0 5px;border-radius:4px}.msg-admire .ico[data-v-66dc36ed],.msg-admire .money[data-v-66dc36ed]{color:#dd374f}", ""]);

// exports
